import { combineReducers } from 'redux-immutable'

import data from './data'
import filters from './filters'
import ui from './ui'
import pagination from './pagination'

export default combineReducers({
  data,
  pagination,
  filters,
  ui
})
